import { omit } from 'remeda';

import { MIME_TYPES } from '@@editor/helpers/Element';
import { type GenerateEmbedBlockData } from '@@editor/typings/Embed';

export const generateEmbedBlockData: GenerateEmbedBlockData = ({ embed, src, originalSrc }) => ({
    mimetype: MIME_TYPES.EMBEDDED_CONTENT,
    src,
    originalSrc,
    // @ts-expect-error This needs a type refactor of the entire `generateEmbedBlock` feature
    // It is not worth it now as we plan to move to PlateJS
    embed: omit(embed, ['iframe', 'nodeKey']),
});
